/**
 * DNH — Country visual centroids (ISO alpha-2 → [lon, lat]).
 * Used to render one live-news dot per reporting country on the world map.
 */
export const COUNTRY_CENTROIDS = {
  AF: [66.0, 33.9], AL: [20.2, 41.2], DZ: [2.6, 28.2], AD: [1.6, 42.5],
  AO: [17.9, -12.3], AG: [-61.8, 17.1], AR: [-65.2, -35.4], AM: [45.0, 40.3],
  AU: [134.5, -25.7], AT: [14.1, 47.6], AZ: [47.7, 40.3], BS: [-77.4, 24.7],
  BH: [50.5, 26.0], BD: [90.4, 23.7], BB: [-59.5, 13.2], BY: [28.0, 53.5],
  BE: [4.6, 50.6], BZ: [-88.7, 17.2], BJ: [2.3, 9.6], BT: [90.4, 27.4],
  BO: [-64.7, -16.7], BA: [17.8, 44.2], BW: [24.7, -22.2], BR: [-53.1, -10.8],
  BN: [114.7, 4.5], BG: [25.2, 42.8], BF: [-1.8, 12.3], BI: [29.9, -3.4],
  KH: [104.9, 12.5], CM: [12.7, 5.7], CA: [-106.3, 56.1], CV: [-23.6, 15.1],
  CF: [20.5, 6.6], TD: [18.6, 15.4], CL: [-71.4, -35.7], CN: [104.2, 35.9],
  CO: [-73.1, 3.9], KM: [43.3, -11.9], CG: [15.2, -0.8], CD: [23.6, -2.9],
  CR: [-84.2, 9.7], CI: [-5.6, 7.6], HR: [16.4, 45.1], CU: [-79.0, 21.5],
  CY: [33.2, 35.0], CZ: [15.3, 49.8], DK: [9.5, 56.0], DJ: [42.6, 11.7],
  DM: [-61.4, 15.4], DO: [-70.5, 18.9], EC: [-78.4, -1.4], EG: [29.9, 26.6],
  SV: [-88.9, 13.8], GQ: [10.3, 1.6], ER: [38.8, 15.4], EE: [25.5, 58.7],
  SZ: [31.5, -26.6], ET: [39.6, 8.6], FJ: [178.0, -17.8], FI: [26.3, 64.5],
  FR: [2.2, 46.6], GA: [11.6, -0.6], GM: [-15.4, 13.4], GE: [43.5, 42.2],
  DE: [10.4, 51.1], GH: [-1.0, 7.9], GR: [22.9, 39.1], GD: [-61.7, 12.1],
  GT: [-90.4, 15.7], GN: [-10.9, 10.4], GW: [-15.1, 12.0], GY: [-58.9, 4.8],
  HT: [-72.7, 19.1], HN: [-86.6, 14.8], HU: [19.4, 47.2], IS: [-18.6, 65.0],
  IN: [78.9, 21.0], ID: [113.9, -0.8], IR: [53.7, 32.4], IQ: [43.7, 33.0],
  IE: [-8.1, 53.2], IL: [34.9, 31.4], IT: [12.6, 42.8], JM: [-77.3, 18.1],
  JP: [138.3, 36.2], JO: [36.8, 31.2], KZ: [66.9, 48.0], KE: [37.9, 0.5],
  KI: [173.0, 1.4], KP: [127.2, 40.1], KR: [127.8, 36.4], KW: [47.6, 29.3],
  KG: [74.5, 41.5], LA: [103.8, 18.5], LV: [24.9, 56.9], LB: [35.9, 33.9],
  LS: [28.2, -29.6], LR: [-9.4, 6.4], LY: [17.2, 27.0], LI: [9.5, 47.1],
  LT: [23.9, 55.2], LU: [6.1, 49.8], MG: [46.7, -19.4], MW: [34.3, -13.2],
  MY: [102.0, 4.2], MV: [73.5, 3.2], ML: [-4.0, 17.6], MT: [14.4, 35.9],
  MH: [168.7, 7.1], MR: [-10.9, 20.3], MU: [57.6, -20.3], MX: [-102.5, 23.6],
  FM: [158.2, 6.9], MD: [28.4, 47.2], MC: [7.4, 43.7], MN: [103.8, 46.9],
  ME: [19.3, 42.8], MA: [-6.3, 31.8], MZ: [35.5, -17.3], MM: [96.5, 21.2],
  NA: [17.2, -22.1], NR: [166.9, -0.5], NP: [84.1, 28.4], NL: [5.3, 52.1],
  NZ: [172.8, -41.8], NI: [-85.0, 12.9], NE: [9.4, 17.4], NG: [8.1, 9.6],
  MK: [21.7, 41.6], NO: [8.5, 61.0], OM: [56.1, 20.6], PK: [69.4, 30.0],
  PW: [134.6, 7.5], PA: [-80.1, 8.5], PG: [144.2, -6.5], PY: [-58.4, -23.4],
  PE: [-75.0, -9.2], PH: [122.9, 12.9], PL: [19.4, 52.1], PT: [-8.5, 39.6],
  QA: [51.2, 25.3], RO: [25.0, 45.9], RU: [90.0, 60.0], RW: [29.9, -2.0],
  KN: [-62.7, 17.3], LC: [-61.0, 13.9], VC: [-61.2, 13.3], WS: [-172.4, -13.6],
  SM: [12.4, 43.9], ST: [6.6, 0.2], SA: [44.5, 24.0], SN: [-14.5, 14.4],
  RS: [20.8, 44.2], SC: [55.5, -4.7], SL: [-11.8, 8.5], SG: [103.8, 1.35],
  SK: [19.5, 48.7], SI: [14.8, 46.1], SB: [160.2, -9.6], SO: [45.9, 6.0],
  ZA: [24.7, -29.0], SS: [30.3, 7.3], ES: [-3.6, 40.2], LK: [80.7, 7.9],
  SD: [29.9, 15.6], SR: [-55.9, 4.1], SE: [16.7, 62.8], CH: [8.2, 46.8],
  SY: [38.5, 35.0], TW: [121.0, 23.7], TJ: [71.0, 38.9], TZ: [34.9, -6.4],
  TH: [101.0, 15.1], TL: [125.8, -8.8], TG: [0.8, 8.6], TO: [-175.2, -21.2],
  TT: [-61.3, 10.4], TN: [9.6, 34.1], TR: [35.2, 39.1], TM: [59.4, 39.1],
  TV: [179.2, -7.1], UG: [32.4, 1.4], UA: [31.4, 49.0], AE: [54.3, 23.9],
  GB: [-2.9, 54.2], US: [-98.6, 39.8], UY: [-55.8, -32.8], UZ: [63.1, 41.7],
  VU: [167.0, -16.0], VA: [12.45, 41.9], VE: [-66.2, 7.1], VN: [106.3, 16.6],
  YE: [47.6, 15.9], ZM: [27.8, -13.5], ZW: [29.9, -19.0],
};

export const centroidForIso2 = (iso2) =>
  COUNTRY_CENTROIDS[(iso2 || "").toUpperCase()] || null;
